(() => {
  if (window.PureCarnivoreSubscriptionOptions) return;

  const SELECTORS = {
    root: '[data-pc-subscription]',
    toggle: '[data-pc-subscription-toggle]',
    intervals: '[data-pc-subscription-intervals]',
    plan: '[data-pc-subscription-plan]',
    sellingPlan: '[data-pc-selling-plan-input]',
    saving: '[data-pc-subscription-saving]',
    toggleSaving: '[data-pc-subscription-toggle-saving]',
    submit: '[id^="ProductSubmitButton-"]',
  };

  const getSubmitLabel = (root) => root.closest('form')?.querySelector(`${SELECTORS.submit} > span`);

  const updateSubmitLabel = (root, active) => {
    const submitLabel = getSubmitLabel(root);
    const submitButton = submitLabel?.closest('button');

    if (!submitLabel || submitButton?.disabled) return;

    if (!submitLabel.dataset.pcOneTimeLabel) {
      submitLabel.dataset.pcOneTimeLabel = submitLabel.textContent.trim();
    }

    submitLabel.textContent = active ? 'Abo in den Warenkorb' : submitLabel.dataset.pcOneTimeLabel;
  };

  const neutralizeInjectedSealInputs = (root) => {
    const form = root.closest('form');
    if (!form) return;

    form.querySelectorAll('.sealsubs-target-element').forEach((widget) => {
      widget.classList.add('pc-seal-widget-source');

      widget.querySelectorAll('[name="selling_plan"]').forEach((input) => {
        if (!input.matches(SELECTORS.sellingPlan)) {
          input.dataset.pcSealInputName = 'selling_plan';
          input.removeAttribute('name');
        }
      });
    });
  };

  const syncSealWidget = (root, sellingPlanId) => {
    const form = root.closest('form');
    if (!form) return;

    form.querySelectorAll('.sealsubs-target-element').forEach((widget) => {
      widget.dispatchEvent(
        new CustomEvent('sealsubs:change_selected_selling_plan_id', {
          detail: { selling_plan_id: sellingPlanId || null },
        })
      );
    });

    window.setTimeout(() => neutralizeInjectedSealInputs(root), 0);
  };

  const updateSaving = (root, plan) => {
    if (!plan) return;

    const discount = plan.dataset.planDiscount || '5';
    const saving = root.querySelector(SELECTORS.saving);
    const toggleSaving = root.querySelector(SELECTORS.toggleSaving);

    if (saving) saving.textContent = `Spare ${discount} %`;
    if (toggleSaving) toggleSaving.textContent = `${discount} % sparen`;
  };

  const applySelectedPlan = (root) => {
    const plan = root.querySelector(`${SELECTORS.plan}:checked`) || root.querySelector(SELECTORS.plan);
    const sellingPlanInput = root.querySelector(SELECTORS.sellingPlan);

    if (!plan || !sellingPlanInput) return;

    sellingPlanInput.value = plan.value;
    sellingPlanInput.disabled = false;
    updateSaving(root, plan);
    syncSealWidget(root, plan.value);
  };

  const setSubscriptionActive = (root, active) => {
    const toggle = root.querySelector(SELECTORS.toggle);
    const intervals = root.querySelector(SELECTORS.intervals);
    const plans = root.querySelectorAll(SELECTORS.plan);
    const sellingPlanInput = root.querySelector(SELECTORS.sellingPlan);

    root.classList.toggle('is-active', active);
    toggle?.setAttribute('aria-checked', String(active));
    toggle?.setAttribute('aria-expanded', String(active));

    if (intervals) intervals.hidden = !active;
    plans.forEach((plan) => {
      plan.disabled = !active;
    });

    if (active) {
      applySelectedPlan(root);
    } else if (sellingPlanInput) {
      sellingPlanInput.value = '';
      sellingPlanInput.disabled = true;
      syncSealWidget(root, null);
    }

    updateSubmitLabel(root, active);
  };

  const initialize = (root) => {
    if (!root || root.dataset.pcSubscriptionInitialized === 'true') return;

    root.dataset.pcSubscriptionInitialized = 'true';
    setSubscriptionActive(root, false);
    neutralizeInjectedSealInputs(root);

    const form = root.closest('form');
    if (form) {
      if (form.dataset.pcSubscriptionFormSanitizer !== 'true') {
        form.dataset.pcSubscriptionFormSanitizer = 'true';
        form.addEventListener('formdata', (event) => {
          Array.from(event.formData.keys()).forEach((key) => {
            if (key.startsWith('pc_subscription_plan_')) event.formData.delete(key);
          });
        });
      }

      const formObserver = new MutationObserver(() => neutralizeInjectedSealInputs(root));
      formObserver.observe(form, { childList: true, subtree: true });
    }
  };

  const initializeAll = (scope = document) => {
    if (scope.matches?.(SELECTORS.root)) initialize(scope);
    scope.querySelectorAll?.(SELECTORS.root).forEach(initialize);
  };

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest(SELECTORS.toggle);
    if (!toggle) return;

    const root = toggle.closest(SELECTORS.root);
    if (!root) return;

    const active = toggle.getAttribute('aria-checked') !== 'true';
    setSubscriptionActive(root, active);
  });

  document.addEventListener('change', (event) => {
    if (!event.target.matches(SELECTORS.plan)) return;

    const root = event.target.closest(SELECTORS.root);
    if (root?.classList.contains('is-active')) applySelectedPlan(root);
  });

  document.addEventListener('sealsubs:subscription_widget_created', (event) => {
    const widget = event.detail?.element || event.target;
    const form = widget?.closest?.('form');
    const root = form?.querySelector(SELECTORS.root);

    if (root) {
      neutralizeInjectedSealInputs(root);

      if (root.classList.contains('is-active')) {
        applySelectedPlan(root);
      }
    }
  });

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));

  const pageObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) initializeAll(node);
      });
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initializeAll();
      pageObserver.observe(document.body, { childList: true, subtree: true });
    });
  } else {
    initializeAll();
    pageObserver.observe(document.body, { childList: true, subtree: true });
  }

  window.PureCarnivoreSubscriptionOptions = { initializeAll, setSubscriptionActive };
})();
